import { DocumentType, ManualSolicitation } from '@/lib/types/apiTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ManualSolicitationState {
	manualSolicitation: ManualSolicitation | null;
	exportDocument: DocumentType | null;
}

const initialState: ManualSolicitationState = {
	manualSolicitation: null,
	exportDocument: null,
};

const manualSolicitationState = createSlice({
	name: 'proposal',
	initialState,
	reducers: {
		clearManualSolicitation(state) {
			state.manualSolicitation = null;
			state.exportDocument = null;
		},
		setManualSolicitation(state, action: PayloadAction<ManualSolicitation>) {
			state.manualSolicitation = action.payload;
			state.exportDocument = null;
		},
		startManualExport(state, action: PayloadAction<DocumentType>) {
			state.exportDocument = action.payload;
		},
		endManualExport(state) {
			state.exportDocument = null;
		},
	},
});

export const {
	clearManualSolicitation,
	setManualSolicitation,
	startManualExport,
	endManualExport,
} = manualSolicitationState.actions;
export default manualSolicitationState.reducer;
